export const maximumNumberOfProductsToCompare = 3;
